__turbopack_context__.v({
  "bottomContainer": "MFlthq_bottomContainer",
  "businessInfo": "MFlthq_businessInfo",
  "businessNumber": "MFlthq_businessNumber",
  "container": "MFlthq_container",
  "infoItemContainer": "MFlthq_infoItemContainer",
  "legalName": "MFlthq_legalName",
  "mapView": "MFlthq_mapView",
  "metaContainer": "MFlthq_metaContainer",
  "orderFormat": "MFlthq_orderFormat",
  "orderFormats": "MFlthq_orderFormats",
  "outletName": "MFlthq_outletName",
  "w30": "MFlthq_w30",
  "w40": "MFlthq_w40",
  "w50": "MFlthq_w50",
  "w60": "MFlthq_w60",
});
